import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface HistoryNavigationState {
  pathname: string;
  ultimoPortalLogado: string;
}

const initialState: HistoryNavigationState = {
  pathname: '/',
  ultimoPortalLogado: '',
};

const slice = createSlice({
  name: 'historyNavigation',
  initialState,
  reducers: {
    setHistoryNavigation(
      state: HistoryNavigationState,
      action: PayloadAction<string>
    ) {
      state.pathname = action.payload;
    },
    setUltimoPortalLogado(
      state: HistoryNavigationState,
      action: PayloadAction<string>
    ) {
      state.ultimoPortalLogado = action.payload;
    },
  },
});

export const { reducer } = slice;

export const { setHistoryNavigation, setUltimoPortalLogado } = slice.actions;
